<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [closable]="true"
  [dismissableMask]="true"
  [draggable]="false"
  [resizable]="false"
  appendTo="body"
  styleClass="file-preview-dialog"
  [style]="{ width: '90vw', maxWidth: '1200px' }"
  [breakpoints]="{ '960px': '95vw' }"
  (onHide)="onHide()">

  <ng-template pTemplate="header">
    <div class="preview-header">
      <i class="fa-solid fa-eye preview-header-icon" aria-hidden="true"></i>
      <div class="preview-header-text">
        <span class="preview-filename" [title]="resolvedName">{{ resolvedName || 'Vista previa' }}</span>
        <span class="preview-filesize" *ngIf="fileSize">{{ formatFileSize(fileSize) }}</span>
      </div>
      <button pButton pRipple type="button"
              *ngIf="canDownload"
              data-test="preview-download"
              aria-label="Descargar archivo"
              icon="pi pi-download"
              class="p-button-rounded p-button-text p-button-success"
              (click)="onDownloadClick()"
              pTooltip="Descargar archivo"
              tooltipPosition="bottom">
      </button>
    </div>
  </ng-template>

  <div class="preview-body">
    <div class="preview-loading" *ngIf="loading">
      <p-progressSpinner styleClass="preview-spinner" strokeWidth="3"></p-progressSpinner>
      <span>Cargando archivo...</span>
    </div>

    <ng-container *ngIf="!loading && kind && blob" [ngSwitch]="kind">
      <app-pdf-viewer *ngSwitchCase="'pdf'" [blob]="blob"></app-pdf-viewer>
      <app-docx-viewer *ngSwitchCase="'docx'" [blob]="blob"></app-docx-viewer>
      <app-xlsx-viewer *ngSwitchCase="'xlsx'" [blob]="blob"></app-xlsx-viewer>
      <app-image-viewer *ngSwitchCase="'image'" [blob]="blob"></app-image-viewer>
      <app-text-viewer *ngSwitchCase="'text'" [blob]="blob"></app-text-viewer>
      <app-unsupported-viewer *ngSwitchDefault
                              [fileName]="resolvedName"
                              [fileUrl]="fileUrl"
                              (downloadRequested)="downloadRequested.emit($event)">
      </app-unsupported-viewer>
    </ng-container>

    <app-unsupported-viewer *ngIf="!loading && error"
                            [fileName]="resolvedName"
                            [fileUrl]="fileUrl"
                            (downloadRequested)="downloadRequested.emit($event)">
    </app-unsupported-viewer>
  </div>

</p-dialog>
